var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenCheckMark = function SvgGreenCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "#4B8B52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.97 18.088 4.522 4.522 10.853-11.757",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGreenCheckMark;